<template>

  <b-container class="pb-5">
    <b-row>
      <b-col lg="3" v-for="(product,index) in getProducts" :key="index">
        <m-c104 :product="product"/>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <div class="ml-auto mr-auto">
        <m-pagination-400 v-if="havePagination" :meta="paginationMeta" :on-change-page="changePage"/>
      </div>

      <slot name="more"/>
    </b-row>
  </b-container>

</template>

<script>
import {mapGetters} from "vuex";
import router from "@/router";
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";


export default {
  name: "OfferProducts101",
  props: ["showNumber", "havePagination"],
  components: {Swiper, SwiperSlide, directive},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          998: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      products: 'Product/getOfferProducts',
      paginationMeta: "Content/getPaginationMeta",
    }),
    getProducts() {
      if (this.showNumber) {
        return this.products.slice(0, this.showNumber)
      } else {
        return this.products
      }
    },
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Product/setProducts", page);
      router.push({name: "Products", query: {...router.currentRoute.query, page: page}})
    }
  },
  async mounted() {
    await this.$store.dispatch('Product/getOfferProducts')
  }
}
</script>

<style scoped>

</style>